import { render, staticRenderFns } from "./solutionHome.vue?vue&type=template&id=2b4cd6f4&"
import script from "./solutionHome.vue?vue&type=script&lang=js&"
export * from "./solutionHome.vue?vue&type=script&lang=js&"
import style0 from "./solutionHome.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports